export function defineLocalIndexedDBStore<T = any>({
  dbName,
  storeName,
  version
}: {
  dbName: string
  storeName: string
  version: number
}) {
  const openLocalDB = () => {
    return new Promise<IDBDatabase>((resolve, reject) => {
      const request = indexedDB.open(dbName, version)
      request.onupgradeneeded = event => {
        const db = (event.target as IDBOpenDBRequest).result

        // delete all object stores
        Array.from(db.objectStoreNames).forEach(name => {
          db.deleteObjectStore(name)
        })

        db.createObjectStore(storeName, { keyPath: 'key' })

        // Delete old stores like this
        // if (db.objectStoreNames.contains('<store name>')) {
        //   db.deleteObjectStore('<store name>')
        //   console.log('Object store deleted!')
        // }
      }
      request.onsuccess = event => {
        resolve((event.target as IDBOpenDBRequest).result)
      }
      request.onerror = event => {
        reject((event.target as IDBOpenDBRequest).error)
      }
    })
  }

  const getValue = async (key: string): Promise<T | undefined> => {
    const db = await openLocalDB()
    return new Promise<T | undefined>((resolve, reject) => {
      const transaction = db.transaction(storeName, 'readonly')
      const store = transaction.objectStore(storeName)
      const request = store.get(key)
      request.onsuccess = () => {
        resolve(request.result?.value)
      }
      request.onerror = () => {
        reject(request.error)
      }
    })
  }

  const setValue = async (key: string, value: T): Promise<void> => {
    const db = await openLocalDB()
    return new Promise<void>((resolve, reject) => {
      const transaction = db.transaction(storeName, 'readwrite')
      const store = transaction.objectStore(storeName)
      const request = store.put({ key, value })
      request.onsuccess = () => {
        resolve()
      }
      request.onerror = () => {
        reject(request.error)
      }
    })
  }

  return {
    getValue,
    setValue
  }
}
